import { createContext, useContext, type ReactNode } from "react";
import { surfaceClasses } from "~/lib/surface-classes";
import { clampSurfaceLevel, type SurfaceLevel } from "~/lib/surface-level";

const SurfaceContext = createContext<SurfaceLevel>(1);

export function useSurface(): SurfaceLevel {
  return useContext(SurfaceContext);
}

export function SurfaceProvider({
  value,
  children,
}: {
  value: number;
  children: ReactNode;
}) {
  return (
    <SurfaceContext.Provider value={clampSurfaceLevel(value)}>
      {children}
    </SurfaceContext.Provider>
  );
}

export function useElevatedSurfaceClasses(
  offset: number,
  shadowLevel?: number,
): { className: string; level: SurfaceLevel } {
  const substrate = useSurface();
  const level = clampSurfaceLevel(substrate + offset);

  return {
    className: surfaceClasses(level, shadowLevel ?? level),
    level,
  };
}
